import apiClient from '@/services/apiClient';

const base = (moduleKey) => `/section-reports/${moduleKey}`;

export const getModuleInternalTransfers = async (moduleKey, params) =>
  (await apiClient.get(`${base(moduleKey)}/internal-transfers`, { params })).data;

export const getModuleInternalTransferDetail = async (moduleKey, transferId) =>
  (await apiClient.get(`${base(moduleKey)}/internal-transfer-detail/${transferId}`)).data;

export const saveModuleInternalTransferErp = async (moduleKey, transferId, erpEntryNo) =>
  (await apiClient.post(`${base(moduleKey)}/internal-transfer-erp/${transferId}`, { erp_entry_no: erpEntryNo })).data;

export const getModuleDocuments = async (moduleKey, params) =>
  (await apiClient.get(`${base(moduleKey)}/documents`, { params })).data;

export const getFobPackedNotTransferred = async (params) =>
  (await apiClient.get('/section-reports/fob/packed-not-transferred', { params })).data;

export const downloadCsv = async (path, params, filename) => {
  const res = await apiClient.get(path, { params, responseType: 'blob' });
  const url = window.URL.createObjectURL(new Blob([res.data], { type: 'text/csv' }));
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};
